export default __webpack_public_path__ + "static/media/plus-primary.8cad267c.svg";